module.exports = __webpack_public_path__ + "static/media/iphone.7e327128.png";